import Img from "gatsby-image"
import { Link } from "gatsby"
import React from "react"
import { Badge, Card } from "react-bootstrap"

export default props => {
  return (
    <Card className="card-project h-100" as={Link} to={props.to}>
      {props.featuredImage ? (
        <Img fluid={props.featuredImage} className="card-img-new" />
      ) : (
        <div className="card-img-placeholder" />
      )}
      <Card.Body className="d-flex flex-column pt-3">
        <Card.Title as="h5">{props.title}</Card.Title>
        <Card.Text className="flex-grow-1">{props.excerpt}</Card.Text>
        {props.tags && props.tags.length > 0 && (
          <div className="mt-2">
            {props.tags.map(tag => (
              <Badge key={tag} pill className="px-2 mr-1 mb-1 badge-violet">
                {tag}
              </Badge>
            ))}
          </div>
        )}
      </Card.Body>
      {props.date && (
        <Card.Footer>
          <small className="card-meta-place">{props.date}</small>
        </Card.Footer>
      )}
    </Card>
  )
}
